import { useEffect, useState } from 'react'
import axios from 'axios'
import bytes from 'bytes'

// Allowed formats and max size per upload kind ('file', 'image', 'video'), as configured server-side.
// Fetched once and shared by all upload components.
let limitsPromise = null

export const fetchUploadLimits = () => {
    if (!limitsPromise) {
        limitsPromise = axios.get('/uploadLimits')
            .then(res => res.data)
            .catch(() => {
                limitsPromise = null // retry on next call
                return null
            })
    }
    return limitsPromise
}

export const useUploadLimits = kind => {
    const [limits, setLimits] = useState(null)
    useEffect(() => {
        let active = true
        fetchUploadLimits().then(data => active && setLimits(data && data[kind]))
        return () => { active = false }
    }, [kind])
    return limits
}

// Resolves to true when the file is bigger than the server limit for this kind
export const isTooLarge = async (file, kind) => {
    const limits = await fetchUploadLimits()
    const maxSize = limits && limits[kind] && limits[kind].maxSize
    return !!maxSize && file.size > maxSize
}

export const formatSize = size => bytes(size, { unitSeparator: ' ' })
